var React = require('react');

function IconTimeCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M506.7 64.5c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445-199.2-445-445-445zM801 600c0 5.5-4.5 10-10 10H488c-5.5 0-10-4.5-10-10V297c0-5.5 4.5-10 10-10h50c5.5 0 10 4.5 10 10v243h243c5.5 0 10 4.5 10 10v50z"}));
}

IconTimeCircleSolid.displayName = "IconTimeCircleSolid";

IconTimeCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconTimeCircleSolid;

IconTimeCircleSolid.default = IconTimeCircleSolid;
